import React from "react";
import { MapPin, Calendar, FileText } from "lucide-react";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageContext";
import { translations } from "../translations";

const AboutUs = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  // Define the company info data with translations
  const companyInfo = [
    {
      icon: Calendar,
      key: "established",
      contentKey: "establishedDate",
    },
    {
      icon: FileText,
      key: "registration",
      contentKey: "registrationNumber",
    },
    {
      icon: MapPin,
      key: "location",
      contentKey: "locationAddress",
    },
  ];

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">
      {/* Header Section */}
      <header className="bg-gray-100 text-gray-900 py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6 mt-4 text-center">
            {translations[language].aboutUs}
          </h1>
          <p className="text-xl opacity-90 text-center">
            {translations[language].MCBWI}
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12 max-w-6xl">
        {/* Welcome Section */}
        <section className="mb-8">
          <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 md:p-10 border border-gray-200">
            <h2 className="text-2xl font-semibold mb-6 text-black">
              {translations[language].Welcome}
            </h2>
            <p className="text-base leading-relaxed mb-4 text-gray-800">
              {translations[language].WelcomeP1}
            </p>
            <p className="text-base leading-relaxed text-gray-800">
              {translations[language].WelcomeP2}
            </p>
          </div>
        </section>

        {/* Company Info Cards */}
        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {companyInfo.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300 border border-gray-200"
            >
              <div className="flex items-center mb-4">
                <item.icon className="text-red-700 mr-3" size={24} />
                <h3 className="text-lg sm:text-xl font-semibold text-black">
                  {translations[language][item.key]}
                </h3>
              </div>
              <p className="text-gray-600 text-sm sm:text-base">
                {translations[language][item.contentKey]
                  .split("<br />")
                  .map((line, i) => (
                    <span key={i} className="block">
                      {line}
                    </span>
                  ))}
              </p>
            </div>
          ))}
        </section>

        {/* Mission Statement */}
        <section className="mb-8">
          <div className="bg-red-600 text-white rounded-xl shadow-lg p-6 sm:p-8 md:p-10">
            <h2 className="text-2xl font-semibold mb-6">
              {translations[language].OurMission}
            </h2>
            <p className="text-base leading-relaxed mb-4">
              {translations[language].OurMissionP1}
            </p>
            <p className="text-base leading-relaxed">
              {translations[language].OurMissionP2}
            </p>
          </div>
        </section>

        {/* Invitation */}
        <section className="mb-16">
          <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 md:p-10 border border-gray-200">
            <h2 className="text-2xl font-semibold mb-6 text-black">
              {translations[language].Invitation}
            </h2>
            <p className="text-base leading-relaxed mb-4 text-gray-800">
              {translations[language].InvitationP1}
            </p>
            <p className="text-base leading-relaxed text-gray-800">
              {translations[language].InvitationP2}
            </p>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center mb-16">
          <button
            onClick={() => navigate("/contact")}
            className="bg-red-600 hover:bg-red-700 text-white py-3 px-8 rounded-lg font-medium text-base sm:text-lg transition-colors duration-300 shadow-md hover:shadow-lg"
          >
            {translations[language].ContactUsToday}
          </button>
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AboutUs;
